export default __webpack_public_path__ + "static/media/background-1x.eb5458f3.jpg";